module.exports = __webpack_public_path__ + "img/pliers.prt.84f79aea.jpg";